module.exports = __webpack_public_path__ + "images/emoji/star.adfb6ecc6a8151ec716d.png";